/**
 * Утилиты для работы с рандомом
 */
export const bRandom = {
    /**
     * Возвращает случайное целое число между [min и max)
     * @param min
     * @param max
     */
    getInt(min: number, max: number): number {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min; //Максимум не включается, минимум включается
    },
    /**
     * Возвращает случайный элемент массива
     * @param array
     */
    pick<T>(array: T[]): T {
        return array[bRandom.getInt(0, array.length)];
    },
    /**
     * Возвращает НОВЫЙ перемешанный массив
     * @param array
     */
    shuffle<T>(array: T[]): T[] {
        let currentIndex = array.length;
        let randomIndex = 0;

        // While there remain elements to shuffle...
        while (currentIndex !== 0) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
        }
        return array;
    },
};
/**
 * Утилиты для работы с рандомом
 */
export const bRandom = {
    /**
     * Возвращает случайное целое число между [min и max)
     * @param min
     * @param max
     */
    getInt(min: number, max: number): number {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min; //Максимум не включается, минимум включается
    },
    /**
     * Возвращает случайный элемент массива
     * @param array
     */
    pick<T>(array: T[]): T {
        return array[bRandom.getInt(0, array.length)];
    },
    /**
     * Возвращает НОВЫЙ перемешанный массив
     * @param array
     */
    shuffle<T>(array: T[]): T[] {
        let currentIndex = array.length;
        let randomIndex = 0;

        // While there remain elements to shuffle...
        while (currentIndex !== 0) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
        }
        return array;
    },
};
